export default __webpack_public_path__ + "d095db2a74c6b9363e08d9951826b57321b59941/206052ae2e9a0890080884cbd9995409.png";